import React, { useState, useEffect, useRef } from "react";
import Header from "../../component/menu/Header";
import { constants } from "../../constant/constants";
import SideMenu from "../../component/menu/SideMenu";
import { message } from "antd";
import useUserStore from "../../stores/store";
import OrderListComponent from "../../component/super-admin/orders/OrderListComponent";
import { DisbursementService } from "../../services/disbursement-service";

export default function DisbursementHistory() {
  const { user, restaurantId } = useUserStore();
  const [salesReportList, setSalesReportList] = useState(null);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalItem, setTotalItem] = useState(0);
  const isFirstRender = useRef(true);
  const [salesFilter, setSalesFilter] = useState({
    restaurantId: '',
    orderNo: "",
    fromDateTime: "",
    toDateTime: "",
    paymentType: "",
  });
  const [isFilterClear, setIsFilterClear] = useState(false);

  async function fetchSalesReportList(filter) {
    try {
      const salesList = await DisbursementService.getOrderList(
        filter,
        user.token.token
      );
      setSalesReportList(salesList.data);
      setPage(salesList.page);
      setPerPage(salesList.perPage);
      setTotalItem(salesList.total);
    } catch (err) {
      // message.error("Something went wrong in serverside. Try again later.");
      return;
    }
  }

  /** init **/
  useEffect(() => {
    fetchSalesReportList(salesFilter, "init");
  }, []);

  /** for pagination */
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (page === 1 && perPage === 10) return;
    const tempFilter = { ...salesFilter, page: page, perPage: perPage };
    fetchSalesReportList(tempFilter);
  }, [page, perPage]);

  useEffect(() => {
    async function fetchData() {
      if (isFilterClear) {
        await fetchSalesReportList(salesFilter);
        setIsFilterClear(false);
      }
    }

    fetchData();
  }, [isFilterClear]);

  function onHandleFilterData() {
    if (page !== 1 || perPage !== 10) {
      setPage(1);
      setPerPage(10);
    }
    const tempFilter = { ...salesFilter, page: 1, perPage: 10 };
    fetchSalesReportList(tempFilter);
  }

  function onHandlePageChange(page, pageSize) {
    setPage(page);
    setPerPage(pageSize);
  }

  function onHandlePageSizeChange(current, size) {
    setPerPage(size);
  }

  return (
    <section>
      <div className="flex flex-col">
        <Header title={""} menu={constants.SUPER_MENU.ORDERS} currentMenuKey={'T_54_S_54_L_3'}/>
        <div className="flex flex-row bg-prewhite px-[12%]">
          <SideMenu title={`Orders`} menu={constants.SUPER_MENU.ORDERS} />
        </div>
        <div className=" mt-[80px] ml-[80px] px-[50px]">
          <h1 className="pt-[50px] pb-[20px] font-bold text-black text-[24px] leading-[24px] cursor-default">
            Disbursement History
          </h1>
          <div className="text-lg text-center">
            Comming Soon
          </div>
        </div>
      </div>
    </section>
  );
}
